module.exports = __webpack_public_path__ + "img/logo-1.f47cd6a0.png";